import { render, staticRenderFns } from "./otherCost.vue?vue&type=template&id=4d55da52&scoped=true&"
import script from "./otherCost.vue?vue&type=script&lang=js&"
export * from "./otherCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55da52",
  null
  
)

export default component.exports